import React from "react"
import { useNavigate } from "react-router-dom"
import { Box, Typography, Stack, Paper } from "@mui/material"
import SideBarLayout from "src/v2/layout/side-bar-layout" 
import ButtonWithIcon from "src/v2/components/Button/Button" 
const MOTOR_EVENTOS_PARAMETROS = "/motor/cadastro-eventos/parametros" 

// ESSA TELA É APENAS PARA SIMULAÇÃO DE NAVEGAÇÃO. O CONTEÚDO SERÁ SUBSTITUÍDO.
export const CadastroEventosPage = () => {
    const navigate = useNavigate()

    // simula novo fluxo
    const handleNovoFluxo = () => {
        navigate(MOTOR_EVENTOS_PARAMETROS)
    }

    // simula edição de cadastro em produção 
    const handleEditarFluxoProd = () => {
        navigate(MOTOR_EVENTOS_PARAMETROS, {
            state: {
                ID: 12345, 
                CETIP: "23K009912",
                VersaoDocumento: 1
            }
        })
    }

    const handleEditarFluxoAndamento = () => {
        navigate(MOTOR_EVENTOS_PARAMETROS, {
            state: {
                ID: null,
                CETIP: "23K009912",
                VersaoDocumento: 1
            }
        })
    }


    return (
        <SideBarLayout
            title="Cadastro de Eventos"
            header={true}
            headerTitle="Cadastro de Eventos"
            headerImage={"/background/eventos_headers.jpg"}
            headerPosition={"1% 41%"}
        >
            <Box
                sx={{
                    marginTop: -4, 
                    paddingBottom: 5,
                    px: { xxxs: 3, md: 3, lg: 0 },
                    display: "flex",
                    flexDirection: "column",
                    gap: 3
                }}
            >
                <Paper
                    square
                    sx={{
                        p: 4,
                        backgroundColor: "background.paper",
                        minHeight: "200px" 
                    }}
                >
                    <Stack spacing={4} alignItems="flex-start">
                        
                        <Box>
                            <Typography variant="h5" color="white.main" gutterBottom>
                                Simulação
                            </Typography>
                        </Box>

                        <Stack direction="row" spacing={2}>
                            <ButtonWithIcon  
                                size="md" 
                                onClick={handleNovoFluxo}
                            >
                                NOVO FLUXO
                            </ButtonWithIcon>

                            <ButtonWithIcon 
                                size="md" 
                                appearance="outlined" 
                                onClick={handleEditarFluxoAndamento}
                            >
                                SIMULAR EDIÇÃO (ANDAMENTO)
                            </ButtonWithIcon>

                            <ButtonWithIcon 
                                size="md" 
                                appearance="outlined" 
                                onClick={handleEditarFluxoProd}
                            >
                                SIMULAR EDIÇÃO (PRODUÇÃO)
                            </ButtonWithIcon>                            
                        </Stack>
                        
                    </Stack>
                </Paper>
            </Box>
        </SideBarLayout>
    )
}